import styled from 'styled-components';
import { environmentLabel } from '../utils/siblingSite';

// 개발(헤츠너 .kr / dev.*)과 운영은 화면이 똑같이 생겼다. 그래서 개발에서
// 만진 것을 운영에서 한 줄 알고 넘어가기 쉽다.
//
// 화면 맨 위에 두면 헤더를 가려 본래 내용이 밀린다. 아래에 고정해 어느
// 화면을 보든 눈에는 들어오되 방해하지 않게 한다.
// 운영에서는 아무것도 그리지 않는다.
const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2147483000;
  width: 100%;
  padding: 5px 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #422006;
  background: repeating-linear-gradient(
    45deg,
    #fbbf24,
    #fbbf24 10px,
    #f59e0b 10px,
    #f59e0b 20px
  );
  border-top: 1px solid #b45309;
`;

const Host = styled.span`
  font-weight: 500;
  opacity: 0.85;
  font-size: 11px;
`;

export default function EnvironmentBadge() {
  const label = environmentLabel();
  if (!label) return null;
  return (
    <Bar role="status" aria-label={`${label} 환경`}>
      {label} 환경 · 운영이 아닙니다
      <Host>{window.location.hostname}</Host>
    </Bar>
  );
}
